const config = {
    controls: true,
    myGui: true
}

export default config